export default __webpack_public_path__ + "static/media/ic_confirm_CRM.bbc23548.svg";